import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function SearchIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M16.0576 10.021C16.0576 13.3347 13.3713 16.021 10.0576 16.021C6.74391 16.021 4.05762 13.3347 4.05762 10.021C4.05762 6.70729 6.74391 4.021 10.0576 4.021C13.3713 4.021 16.0576 6.70729 16.0576 10.021ZM14.9182 16.3756C13.5709 17.4077 11.8859 18.021 10.0576 18.021C5.63934 18.021 2.05762 14.4393 2.05762 10.021C2.05762 5.60272 5.63934 2.021 10.0576 2.021C14.4759 2.021 18.0576 5.60272 18.0576 10.021C18.0576 11.8858 17.4196 13.6016 16.3499 14.962L21.6493 19.2706C22.0779 19.619 22.1428 20.2489 21.7944 20.6774C21.446 21.1059 20.8162 21.1709 20.3876 20.8224L14.9182 16.3756Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<SearchIcon fill={props.fill} />
		</div>
	);
}